import { Typography } from '@mui/material';

export function AppraisalsPage() {
  return (
    <Typography variant="h4" component="h1">
      Appraisals
    </Typography>
  );
}

export default AppraisalsPage;
